import axios from '@/libs/api.request'
// 搜索海校库所有学校
export const getOverseasUnivers = data => {
  return axios.request({
    url: '/overseas/univ/name/list',
    data,
    method: 'POST'
  })
}
// 根据学校搜项目名称
export const getOverseasProjectSimple = data => {
  return axios.request({
    url: '/overseas/project/simple',
    data,
    method: 'POST'
  })
}
// 根据学校搜索院校
export const getOverseasCollegeNameList = data => {
  return axios.request({
    url: '/overseas/college/name/list',
    data,
    method: 'POST'
  })
}
